// extracted by mini-css-extract-plugin
export default {"container":"AboutMission_container__hNi2-","vision":"AboutMission_vision__EhZZ3","mission":"AboutMission_mission__pi2In","welcome":"AboutMission_welcome__6TmYI"};